import { render, staticRenderFns } from "./ActionImage.vue?vue&type=template&id=1a4938ab&"
import script from "./ActionImage.vue?vue&type=script&lang=js&"
export * from "./ActionImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports